import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormHexagon: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-hexagon"><path d="M12 2.25L20.4437 7.125V16.875L12 21.75L3.55625 16.875V7.125L12 2.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFormHexagon;
